import { CardRestriction } from "../../models/TournamentFormat";
import { CardVariantImage } from "../../components/CardVariantImage/CardVariantImage";
import { CardVariant } from "../../models/CardVariant";
import { CardVariantImageLinkOverlay } from "../../components/CardVariantImage/CardVariantImageLinkOverlay";

export type CardRestrictionComponentProps = {
    variant: CardVariant,
    restriction: CardRestriction
}

export function CardRestrictionComponent(props: CardRestrictionComponentProps) {
    return <div className="grid grid-cols-2 md:grid-cols-4 xl:grid-cols-6 gap-4">
        <CardVariantImage
            key={props.variant.id}
            variant={props.variant}
            classNames={{ container: "col-span-1" }}
            overlay={<>
                <CardVariantImageLinkOverlay variant={props.variant} />
            </>} />

        <div className="col-span-1 md:col-span-2 rounded-2xl font-medium">
            <div>{props.restriction.description}</div>
            <a href={props.restriction.source} target="_blank" className="text-emphasis-secondary">Source</a>
        </div>
    </div>
}